import { Icon, IconName, IconProps } from '@flatfile/baseline'

// Mapping of old icon names to new baseline icon names
export const iconMapping: { [key: string]: IconName } = {
  IconApps: 'app',
  IconAvocado: 'avocado',
  IconBackhoe: 'shovel',
  IconBrandChrome: 'circle',
  IconBuildingArch: 'bank',
  IconCalendarRepeat: 'calendar-3',
  IconCalendarStats: 'calendar-1',
  IconCamera: 'camera-1',
  IconCat: 'cat',
  IconCategory: 'square-grid-circle',
  IconCategory2: 'layout-grid-2',
  IconChartArcs3: 'live-activity',
  IconChartArrows: 'trending-4',
  IconCircles: 'circles-three',
  IconCloudBolt: 'rainy-light',
  IconCloudStar: 'cloudy-sun',
  IconCube: 'ar-cube-1',
  IconDatabaseHeart: 'bubble-heart',
  IconDeviceDesktopAnalytics: 'imac',
  IconFish: 'hat-bunny',
  IconFlame: 'fire-1',
  IconGift: 'gift-1',
  IconHandStop: 'hand-5-finger',
  IconHearts: 'heart',
  IconHorseToy: 'unicorn',
  IconId: 'postcard-2',
  IconKarate: 'electrocardiogram',
  IconLeaf: 'growth',
  IconMacro: 'flower',
  IconMoodSmile: 'emoji-smile',
  IconMoustache: 'trash-paper',
  IconPaw: 'pets',
  IconPlanet: 'earth',
  IconPrism: 'arrow-triangle-top',
  IconRipple: 'haptic',
  IconRocket: 'rocket',
  IconRollercoaster: 'basket-1',
  IconSchool: 'school',
  IconSitemap: 'bezier-curve',
  IconSubmarine: 'drop',
  IconSunHigh: 'sunrise',
  IconSwords: 'sword',
  IconTools: 'toolbox',
  IconTrafficLights: 'light-bulb',
  IconTruckDelivery: 'truck',
  IconUser: 'people',
  IconUserExclamation: 'people-like',
  IconNumbers: 'numbered-list',
  IconDashboard: 'analytics',
  IconRouteSquare: 'map-pin-flat',
  IconBoxPadding: 'cmd-box',
  IconBriefcase: 'bag-2',
}

// Create a reverse mapping for validation
export const validBaselineIcons = new Set([...Object.values(iconMapping)])

type IconMapperProps = {
  iconName?: IconName // Make iconName optional to handle undefined cases
  size?: IconProps['size']
  className?: string
  namespace?: string
}

/**
 * Renders an icon using the new baseline Icon component
 * Works with both old format icon names (like "IconApps") and new format (like "app")
 */
export const renderMappedIcon = ({ iconName, size = 16, className = '', namespace }: IconMapperProps) => {
  if (!iconName && namespace) {
    switch (namespace) {
      case 'portal':
        return <Icon name='cmd-box' className='text-primary' />
      case 'projects':
        return <Icon name='bag-2' className='text-primary' />
      case 'mapping':
        return <Icon name='map-pin-flat' className='text-primary' />
      case 'workbooks':
        return <Icon name='table' className='text-primary' />
      default:
        return <Icon name='app' className='text-primary' />
    }
  }
  // Handle undefined or empty iconName
  if (!iconName) {
    return <Icon name='app' size={size} className={className} />
  }

  // Case 1: Old format - convert from key to value
  if (iconName in iconMapping) {
    return <Icon name={iconMapping[iconName as keyof typeof iconMapping]} size={size} className={className} />
  }

  // Case 2: New format - already a baseline icon name
  if (validBaselineIcons.has(iconName)) {
    return <Icon name={iconName} size={size} className={className} />
  }

  // Fallback for unrecognized icon names
  console.warn(`Unrecognized icon name: ${iconName}, falling back to default`)
  return <Icon name='app' size={size} className={className} />
}
